import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import AISEA_API from "@/http/aisea/axios";
const epManningVesselApi = AiseaApiFactory.get("enterpriseManningVessel");
const epCrewDataManagementApi = AiseaApiFactory.get(
  "enterpriseCrewDataManagement"
);

export default {
  async fetchDataManagementFunctionScheme({ _ }) {
    try {
      let response = await epCrewDataManagementApi.fetchDataManagementDisplayConfigurations();
      return { success: true, data: response.data.conf.functionScheme };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  async fetchManningVessels({ commit }) {
    let response = await epManningVesselApi.search({ page: 0, size: 999 });
    commit("SET_MANNING_VESSELS", response.data.manning_vessels);
  },

  async fetchLatestCutoffDate({ commit }) {
    let response = await epCrewDataManagementApi.fetchCurrentCutoffDate();
    commit(
      "SET_LATEST_CUTOFF_DATE",
      response.data.manning_by_vessel_cutoff_date
    );
  },

  async executeDynamicApi({ dispatch, commit }, payload) {
    try {
      const { processType, api, params } = payload;
      const { method, path } = api;

      // APIのpathが未設定の場合は実行しない
      if (!api.path) {
        return {
          success: false,
          userMessage:
            "APIのPathが未設定です。データ管理の設定ファイルを確認してください",
        };
      }

      // ダウンロード処理
      if (processType === "download" && method === "GET") {
        const response = await AISEA_API.get(path, {
          params: params,
          responseType: "blob",
          paramsSerializer: { indexes: null },
        });

        if (response.status) {
          return {
            success: true,
            processType: processType,
            data: response.data,
          };
        } else {
          // Blob をテキストに変換してから JSON を解析
          const errorText = await response.data.text();
          const errorObject = JSON.parse(errorText);
          let errorMessage =
            errorObject.message || "不明なエラーが発生しました。";
          return {
            success: false,
            title: "",
            processType: processType,
            userMessage: errorMessage,
          };
        }
      }

      // アップロード処理
      if (processType === "upload" && method === "POST") {
        if (!params) throw new Error("アップロードデータが不足しています");

        const response = await AISEA_API.post(path, params.file, {
          headers: {
            "content-Type": "multipart/form-data",
          },
        });

        if (response.status) {
          return {
            success: true,
            processType: processType,
            data: response.data,
          };
        } else {
          return {
            success: false,
            processType: processType,
            userMessage: await dispatch("generateErrorMessage", response),
          };
        }
      }

      // 月次締め処理
      if (processType === "vesselCutoff" && method === "PUT") {
        const response = await AISEA_API.put(path, params);

        if (response.status) {
          let newCutoffDate = response.data.manning_by_vessel_cutoff_date;

          // 直帰の締日を更新
          commit("SET_LATEST_CUTOFF_DATE", newCutoffDate);

          return {
            success: true,
            processType: processType,
            userMessage: `締め日：${newCutoffDate}`,
          };
        } else {
          return {
            success: false,
            processType: processType,
            userMessage: await dispatch("generateErrorMessage", response),
          };
        }
      }

      // その他のメソッドを動的に対応
      const response = await AISEA_API({ method, url: path });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        userMessage: error.message || "APIリクエスト中にエラーが発生しました",
      };
    }
  },

  async generateErrorMessage({ _ }, apiResponse) {
    const { data } = apiResponse;
    const { message } = data;

    const userMessage = message || "不明なエラーが発生しました。";
    return `${userMessage}`.trim();
  },
};
